import { RoutePath } from './types';

export const labelsByRoute: Record<RoutePath, string> = {
  [RoutePath.Main]: 'Бронирование мест',
  [RoutePath.Administrator]: 'Администрирование',
  [RoutePath.DeskBooking]: 'Рабочие места',
  [RoutePath.Parking]: 'Парковочные места',
  // [RoutePath.Feedback]: 'Обратная связь',
  [RoutePath.MyBookings]: 'Мои бронирования',
  [RoutePath.Search]: 'Поиск коллеги',
  [RoutePath.RoomBooking]: 'Комнаты',
  [RoutePath.Spaces]: 'Пространства',
};
